module.exports = __webpack_public_path__ + "media/images/sports_coaching/main_image2-aad44eaf2956e23262cd0a4bb38ad902.jpg";